import type { IconProps } from '../types/IconProps.ts';
export const Wrench: IconProps = {
    name: 'Wrench',
    children: [
        `<path d="m10.5 10.5-5.72 5.72a1.98 1.98 0 0 0 2.75 2.85l5.97-5.57M18 2.5l-2.86 3.22a1.82 1.82 0 0 0 2.65 2.5L21 5M18 2.5a4 4 0 0 0-2-.5 6 6 0 0 0-5.5 8.4M21 5c.56.91 1 1.85 1 3a6 6 0 0 1-8.4 5.5" />`,
    ]
};